import { Partial } from '@40seas/entities/common';
import { CreateComplyAdvantageDto } from './create.comply-advantage.dto';

export class UpdateComplyAdvantageDto extends Partial(CreateComplyAdvantageDto) {}
